export class CalculatorBase {
    private gaCategory = "calculator";
    private gaLabel: string;
    private gaStartTime: Date;
    private gaCalculateTime: Date;

    constructor(gaLabel: string) {
        this.gaLabel = gaLabel;
        this.gaStartTime = new Date();
        //        ga("send", "event", this.gaCategory, "show", this.gaLabel);
        gtag("event",
            "show",
            {
                "event_category": this.gaCategory,
                "event_label": this.gaLabel
            });
    }

    calculate(e: JQuery.SubmitEvent) {
        e.preventDefault();

        this.gaCalculateTime = new Date();
        //        ga("send", "event", this.gaCategory, "calculate", this.gaLabel, this.gaCalculateTime.getTime() - this.gaStartTime.getTime());
        gtag("event",
            "calculate",
            {
                "event_category": this.gaCategory,
                "event_label": this.gaLabel,
                "value": this.gaCalculateTime.getTime() - this.gaStartTime.getTime()
            });
    }
}
